import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CanShowInfoPipe } from './canshowinfo.pipe';
import { TransPipe } from './trans.pipe';

@NgModule({
  declarations: [TransPipe, CanShowInfoPipe],
  imports: [
    CommonModule
  ], exports: [
    TransPipe,
    CanShowInfoPipe
  ]
})
export class PipesModule { }
